import type { RequestActivityRequestType } from './enums'

export const RequestActivityQueryKeys = {
  All: () => ['request-activity'],
  ForRequest: (requestType: RequestActivityRequestType, requestId: string) => [
    ...RequestActivityQueryKeys.All(),
    requestType,
    requestId
  ]
}
